import { Button, Form, Space, Radio } from 'antd'
import React, { useState, Fragment, useImperativeHandle } from 'react'
import { Modal } from 'antd'
import User from '@/modules/user'
const Org = (props) => {
  const user = new User()
  const [form] = Form.useForm()

  // 属性
  const [createModalVisible, handleModalVisible] = useState(false)
  const [orgVal, handleOrgVal] = useState()

  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })

  const open = () => {
    form.setFieldsValue({ org: user.getOrgList()[0]?.id })
    handleModalVisible(true)
  }

  const onChange = e => {
    form.setFieldsValue({ org: e.target.value })
    handleOrgVal(e.target.value)
    return e.target.value
  }

  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px'
  }
  const orgStyle = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '200px',
    overflow: 'hidden',
    display: 'inline-block',
    verticalAlign: 'bottom'
  }
  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 }
  }

  const orgLayout = {
    wrapperCol: { offset: 2 }
  }

  // 处理跳转
  const onFinish = async(values) => {
    handleModalVisible(false)
    const org = user.getOrgList().find(item => item.id === values.org)
    if (org) {
      const orgInfo = {
        orgId: org.id,
        orgNm: org.nm
      }
      props.handleOrgChoosed(orgInfo)
    }
  }

  return (
    <Fragment>
      <Modal
        destroyOnClose
        centered
        title='请选择组织'
        visible={createModalVisible}
        onCancel={() => handleModalVisible(false)}
        footer={null}
        width={400}
      >
        <Form
          name='normal_login'
          form={form}
          onFinish={onFinish}
        >

          <Form.Item name='org' {...orgLayout}>
            <Radio.Group onChange={onChange} value={orgVal}>
              {
                user.getOrgList().map(item => {
                  return (<Radio style={radioStyle} key={item.id} value={item.id}>
                    <span style={orgStyle} title={item.nm}>{item.nm}</span>
                  </Radio>)
                })
              }
            </Radio.Group>
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Space>
              <Button onClick={() => handleModalVisible(false)} >
                  取消
              </Button>
              <Button type='primary' htmlType='submit' >
                  确定
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  )
}

export default Org
